import React, {FC, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Helmet} from 'react-helmet-async';

import CooperationModal from 'components/CooperationModal';
import {PageTitle} from 'components';

import useScrollReveal from './hooks/useScrollReveal';
import {getJsonLd} from './seo';
import Cta from './sections/Cta';
import Hero from './sections/Hero';
import Products from './sections/Products';
import Stats from './sections/Stats';
import Trust from './sections/Trust';

/** SEO 文案照抄设计稿 head；og-image 为部署在 /home/ 下的迁移资源 */
const HOME_OG_IMAGE = 'https://www.xiangjifanyi.com/home/og-image.jpg';

/**
 * 新版首页（v3），照抄设计稿 docs/designs/xiangji_home_v3/index.html 的区块序列：
 * Hero（轨道舞台）→ 数据统计 → 五大AI服务 → 信任背书（跑马灯+评价）→ CTA。
 * 导航与页脚由 Layout 统一渲染，不在此文件内。
 * useScrollReveal 挂在根节点，管全部 .scroll-reveal 元素的入场显现。
 */
const Home: FC = () => {
  const [isCooperationOpen, setIsCooperationOpen] = useState(false);
  const revealRef = useScrollReveal<HTMLDivElement>();
  const {i18n, t} = useTranslation('home');

  return (
    <div className="v3-scope pt-20" ref={revealRef}>
      <PageTitle
        appendSuffix={false}
        canonicalUrl="https://www.xiangjifanyi.com/home/"
        description={t('seo.description')}
        ogDescription={t('seo.ogDescription')}
        ogImageUrl={HOME_OG_IMAGE}
        ogTitle={t('seo.ogTitle')}
        ogUrl="https://www.xiangjifanyi.com/home/"
        title={t('seo.title')}
      />
      <Helmet>
        <meta content="index, follow" name="robots" />
        <meta content="#4f46e5" name="theme-color" />
        <script type="application/ld+json">{JSON.stringify(getJsonLd(i18n.language))}</script>
      </Helmet>
      <CooperationModal isOpen={isCooperationOpen} onClose={() => setIsCooperationOpen(false)} />
      <Hero onDemoClick={() => setIsCooperationOpen(true)} />
      <Stats />
      <Products />
      <Trust />
      <Cta />
    </div>
  );
};

export default Home;
